export const PlanStepStatus = {
  Neural: 'neural',
  Furniture: 'furniture',
  Unreal: 'unreal',
  Gltf: 'gltf',
};

export const PlanStepStatusNames = {
  [PlanStepStatus.Neural]: 'Нейронка',
  [PlanStepStatus.Furniture]: 'Фурнитурка',
  [PlanStepStatus.Unreal]: 'Анрил',
  [PlanStepStatus.Gltf]: 'GLTF',
};

export const PlanStepStatusesByValue = {
  '-1': { name: 'Ошибка', color: 'error' },
  0: { name: 'Ожидание', color: null },
  1: { name: 'Обработка', color: 'processing' },
  2: { name: 'Завершено', color: 'success' },
};

export const PlanStepStatusOptions = Object.entries(PlanStepStatusNames).map(([value, label]) => ({ value, label }));
